export function menu(){
    const body = document.body;
    const hamburger = document.querySelector('.hamburger') as HTMLElement | null;
    const closeBtn = document.querySelector('.button-close') as HTMLElement | null;

    // Открытие меню
    hamburger?.addEventListener('click', () => {
        body.classList.add('menu-active');
    });

    // Закрытие меню
    closeBtn?.addEventListener('click', () => {
        body.classList.remove('menu-active');
    });
}